import { authenticatedApi } from '../api';

export const API_CHAT_PATH = '/channel/chat';

export const fetchChatMessages = (studioId) => authenticatedApi.get(
	`${API_CHAT_PATH}/messages/${studioId}`,
);

export const sendMessage = (studioId, role, text, images, videos) => authenticatedApi.post(
	`${API_CHAT_PATH}/messages/byStudioId/${studioId}`,
	{ role, text, images, videos },
);

export const updateChatMessage = (id, text, images, videos) => authenticatedApi.put(
	`${API_CHAT_PATH}/messages/${id}`,
	{ text, images, videos },
);

export const deleteMessage = (id) => authenticatedApi.delete(
	`${API_CHAT_PATH}/messages/${id}`,
);

export const clearChat = (studioId) => authenticatedApi.delete(
	`${API_CHAT_PATH}/messages/byStudioId/${studioId}`,
);
